var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pack-item-container"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"pack-item-data"},[_vm._v(" "+_vm._s(item)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }